// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4dfb09ea","401":"5004d717","455":"1c8b2b6b","488":"308d28d8","977":"b039866d"}[chunkId] + ".chunk.js";
};